/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const reviewOverviewNodes = Array.from(document.querySelectorAll('.review-overview'));
if (reviewOverviewNodes.length) {
    import(/* webpackChunkName: "ReviewOverview" */ './components/ReviewOverview').then(({ default: ReviewOverview }) => {
        reviewOverviewNodes.forEach((node) => render(<ReviewOverview {...parseDataToProps(node.dataset)} />, node));
    });
}
